import {useEffect} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import actions from 'redux-auto'

const ausbilderListeSelector = state => state.meineAusbilder.ausbilderListe
const isLoadingSelector = state => state.meineAusbilder.loading.getUserAusbilder
// eslint-disable-next-line max-len
const canManageMeineAusbilderSelector = state => state.authentication.permissions.meineAusbilder.manage

export function useUserAusbilderListe() {
  const ausbilderListe = useSelector(ausbilderListeSelector, shallowEqual) || []
  const isLoading = useSelector(isLoadingSelector)
  const canViewMeineAusbilder = useSelector(canManageMeineAusbilderSelector)

  useEffect(() => {
    if (canViewMeineAusbilder && ausbilderListe.length === 0) {
      actions.meineAusbilder.getUserAusbilder()
    }
  }, [canViewMeineAusbilder])

  return {ausbilderListe, isLoading}
}
